module.exports = __webpack_public_path__ + "static/img/lyewm.8556118.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/lyewm.jpg
// module id = Fmli
// module chunks = 1